var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3342 13C10.7636 13.5741 11.3115 14.0491 11.9407 14.3929C12.5699 14.7367 13.2657 14.9411 13.9808 14.9923C14.696 15.0435 15.4138 14.9403 16.0855 14.6897C16.7573 14.4392 17.3673 14.047 17.8742 13.54L20.8742 10.54C21.785 9.59695 22.2889 8.33394 22.2776 7.02296C22.2662 5.71198 21.7403 4.45791 20.8133 3.53087C19.8862 2.60383 18.6322 2.07799 17.3212 2.0666C16.0102 2.0552 14.7472 2.55918 13.8042 3.46997L12.0842 5.17997M14.3342 11C13.9047 10.4258 13.3568 9.95078 12.7276 9.60703C12.0984 9.26327 11.4027 9.05885 10.6875 9.00763C9.97239 8.95641 9.2546 9.0596 8.58284 9.31018C7.91108 9.56077 7.30107 9.9529 6.79418 10.46L3.79418 13.46C2.88339 14.403 2.37942 15.666 2.39081 16.977C2.40221 18.288 2.92805 19.542 3.85509 20.4691C4.78213 21.3961 6.03619 21.9219 7.34718 21.9333C8.65816 21.9447 9.92117 21.4408 10.8642 20.53L12.5742 18.82",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChain);
export default __webpack_public_path__ + "static/media/chain.157cbec8383ab6758a6f4bfea3d839fc.svg";
export { ForwardRef as ReactComponent };